import React from 'react'
import PropTypes from "prop-types"

import './style.scss'

export const Grid = (props) => {
    return (
        <div className="grid">
            {props.children}
        </div>
    )
}

export const Col = ({ children, sm, md, lg, smorder, mdorder, lgorder }) => {
    return (
        <div className={`col sm-${sm} md-${md} lg-${lg} sm-order-${smorder} md-order-${mdorder} lg-order-${lgorder}`}>
            {children}
        </div>
    )
}

Col.propTypes = {
    sm: PropTypes.number,
    md: PropTypes.number,
    lg: PropTypes.number,
    smorder: PropTypes.number,
    mdorder: PropTypes.number,
    lgorder: PropTypes.number
}

Col.defaultProps = {
    sm: 12,
    md: 12,
    lg: 12,
    smorder: 0,
    mdorder: 0,
    lgorder: 0
}